import jwtDecode from "jwt-decode";
import apiRequest from "../apiRequest";

class AuthenticationService {
  static AUTH_STORAGE_PATH = "logged_user";
  static AUTH_TIME = 2 * 3600 * 1000; // 2h

  static getUserData() {
    const authObj = JSON.parse(localStorage.getItem(this.AUTH_STORAGE_PATH));

    if (authObj) {
      return authObj;
    }
    return undefined;
  }

  static getUserScopes() {
    const token = this.getAuthToken();

    if (token) {
      const { scopes } = jwtDecode(token);

      return scopes;
    }
    return [];
  }

  static getAuthToken() {
    const authObj = JSON.parse(localStorage.getItem(this.AUTH_STORAGE_PATH));

    if (authObj && authObj.access_token) {
      if (
        (authObj.expires && authObj.expires_at > Date.now()) ||
        !authObj.expires
      )
        return authObj.access_token;

      this.deleteAuthToken();
      return undefined;
    }
    return undefined;
  }

  static setAuthToken(token, userData, expires = true) {
    const now = Date.now();
    const expires_at = expires ? now + this.AUTH_TIME : -1;

    const authObj = {
      ...userData,
      access_token: token,
      expires,
      expires_at,
    };

    localStorage.setItem(this.AUTH_STORAGE_PATH, JSON.stringify(authObj));
  }

  static deleteAuthToken() {
    localStorage.removeItem(this.AUTH_STORAGE_PATH);
  }

  static async login(username, password) {
    const data = new FormData();
    data.append("username", username);
    data.append("password", password);

    const { access_token, user_data } = await apiRequest.post(
      "/auth/login",
      data,
      {
        publicRequest: true,
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    const token = access_token;
    if (token) {
      this.setAuthToken(token, user_data);
    }

    window.location = "/preventivi";
  }

  static logout() {
    this.deleteAuthToken();
  }

  static isUserAuthenticated() {
    const access_token = this.getAuthToken();
    return !!access_token;
  }

  static authHeader() {
    if (this.isUserAuthenticated())
      return {
        Authorization: `Bearer ${this.getAuthToken()}`,
      };

    return false;
  }
}

export default AuthenticationService;
